<template>
	<div class="wutuNewlist">
		<ul>
      <li v-for="(item,index) in dataList" :key='item.ID' class=" fadeInUp" :data-wow-delay="index/6+'s'">
          <router-link  :to="item.Url" :href="item.Url"  @click.native="OpenLink(item.Url)"  >
              <div class="time">
                <p>{{setTimeformat(item.ShowTime,'dd') }}</p>
                <span>{{setTimeformat(item.ShowTime,'yyyy-mm') }}</span>
              </div>
              <div class="title">
                <h3 v-html="item.Title"></h3>
                <p v-html="item.Describe"></p>
              </div>
              <div class="right-txt">
                <em></em>
              </div>
          </router-link>
      </li>
    </ul>
	</div>
</template>

<script>
	export default{
		name:'wtxwlbList',
		props:{
			dataList:{
				type: Array,
				default: () => []
			},
			moreLink: {
			   type: String,
			   default: ''
			}
		},
		methods:{
			setTimeformat(_data,_format='yyyy-mm-dd'){
				return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
			},
			hoverRoll(_data){
			    this.item = _data
			}
		}
	}
</script>

<style lang='less' scoped>
.wutuNewlist{
  width: 1200px;
ul{
        li{
          width: 1200px;
          height: 140px;
          background-color: #fafafa;
          margin-bottom: 20px;
          &:last-child{
            margin-bottom: 0px;
          }
          &:hover{
            a{
              .right-txt{
                em{
                  background: url(../assets/img/icon_hover.png) center no-repeat;
                }
              }
            }
          }
          a{
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-between;
            .time{
              width: 120px;
              height: 140px;
              background-color: #0384c6;
              box-sizing: border-box;
              margin: 0;
              p{
                font-size: 46px;
                font-weight: bold;
                font-stretch: normal;
                line-height: 1;
                letter-spacing: 5px;
                color: #ffffff;
                margin-top: 30px;
                margin-bottom: 20px;
                text-align: center;
              }
              span{
                display: block;
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 16px;
                letter-spacing: 1px;
                color: #ffffff;
                text-align: center;
              }
            }
            .title{
              width: 840px;
              margin-left: 30px;
              h3{
                font-size: 18px;
                font-weight: bold;
                font-stretch: normal;
                line-height: 42px;
                letter-spacing: 2px;
                color: #333333;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                position: relative;
                margin-top: 15px;
                &::after{
                content: "";
                width: 182px;
                height: 1px;
                background-color: #dadada;
                position: absolute;
                left: 0;
                bottom: 0;
              }
            }
              p{
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 24px;
                letter-spacing: 2px;
                color: #666666;
                margin-top: 20px;
                text-overflow: ellipsis;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
            }
            .right-txt{
              width: 210px;
              display: flex;
              align-items: center;
              em{
                display: block;
                width: 100%;
                height: 100%;
                background: url(../assets/img/icon.png) center no-repeat;
                background-size: 42px 42px;
              }
            }
          }
        }
      }
}
</style>




// WEBPACK FOOTER //
// src/components/noImgList2.vue